<template>
  <span v-if="badges.length" class="nrd-media-badges">
    <rmr-soft-badge
      v-for="badge in badges"
      :key="badge.label"
      :label="badge.label"
      :color="badge.color"
      :background="badge.background"
      :icon="badge.icon"
      size="sm"
    />
  </span>
</template>

<script>
import { computed } from "@vue/composition-api";
import { mdiPlayCircleOutline, mdiTextBoxOutline } from "@mdi/js";

import RmrSoftBadge from "@/components/ui/feedback/RmrSoftBadge.vue";

// Le support n'est pas porté par l'article mais par la configuration de
// veille : c'est elle qui déclare si ce compte est suivi pour son écrit ou
// pour ses vidéos.
const PRESENTATION = {
  written: {
    label: "Écrit",
    icon: mdiTextBoxOutline,
    color: "#5B6478",
    background: "#EEF1F6",
  },
  video: {
    label: "Vidéo",
    icon: mdiPlayCircleOutline,
    color: "#7C4DFF",
    background: "#F1EBFF",
  },
};

export default {
  name: "MediaTypeBadge",
  components: { RmrSoftBadge },
  props: {
    // Une LISTE, parce qu'une même entrée peut être suivie par plusieurs sites
    // et, par un même site, dans les deux supports. Sans site sélectionné la
    // vue les mélange : c'est ce tag qui dit ce qu'on regarde, et en afficher
    // un seul serait un mensonge silencieux.
    mediaTypes: {
      type: Array,
      default: () => [],
    },
  },
  setup(props) {
    return {
      badges: computed(() =>
        (props.mediaTypes || [])
          .map((mediaType) => PRESENTATION[mediaType])
          .filter(Boolean)
      ),
    };
  },
};
</script>

<style lang="scss" scoped>
.nrd-media-badges {
  display: inline-flex;
  flex-wrap: wrap;
  gap: 4px;
}
</style>
